import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import { QuoteCardWithScores } from '@marketing/components/testimonial_card';

import ArrowWithLoop from './assets/arrow_with_loop.png';
import Avatars from './assets/avatars.png';
import TrustpilotLogo from './assets/trustpilot_logo.svg';
import marketingStyles from '@marketing/style.module.scss';

interface Props {
  avatars?: string;
  quotes: {
    content: string | React.ReactNode;
    scores: {
      name: string;
      score: number | string;
    }[];
    studentAffiliation?: string;
    studentName: string;
  }[];
  showAllQuotesOnMobile?: boolean;
  tagline: string;
}

export default (props: Props) => {
  return (
    <div className="d-flex flex-column gap-m">
      <div
        className="align-items-center align-items-lg-start d-flex gap-s"
        style={{ position: 'relative' }}
      >
        <div className="align-items-center d-flex flex-1 flex-lg-none flex-column flex-lg-row gap-s">
          <div>
            <img src={props.avatars || Avatars} alt="Small pictures of happy students" height="24px" width="81px" />
          </div>

          <div className="text-inter" style={{ color: '#5C5C5C' }}>
            {props.tagline}
          </div>
        </div>

        <div className="hidden-xs hidden-sm">
          <img
            alt="Arrow pointing down to student testimonials"
            height="50px"
            src={ArrowWithLoop}
            width="80px"
          />
        </div>

        <div
          className="visible-xs visible-sm"
          style={{ position: 'absolute', right: -5, top: 75, transform: 'rotate(85deg)', zIndex: 10 }}
        >
          <img
            alt="Arrow pointing down to student testimonials"
            height="50px"
            src={ArrowWithLoop}
            width="80px"
          />
        </div>
      </div>

      <div
        className={cx('d-flex', props.showAllQuotesOnMobile ? 'flex-column flex-lg-row' : 'hidden-xs hidden-sm')}
        style={{ gap: 18 }}
      >
        {
          props.quotes.map((quote, idx) => {
            const skewAngle = [2.5, -2.5][idx % 2];

            return (
              <QuoteCardWithScores key={idx} {...quote} skewAngle={skewAngle}>
                {quote.content}
              </QuoteCardWithScores>
            )
          })
        }
      </div>

      {!props.showAllQuotesOnMobile && <div className="d-flex u-padding-A-l visible-xs visible-sm" style={{ position: 'relative' }}>
        <Card
          skewAngle={2}
          style={{
            // Parent large padding is 31px on each side
            height: 'calc(100% - 62px)',
            left: 31,
            position: 'absolute',
            top: 31,
            width: 'calc(100% - 62px)'
          }}
        />

        <QuoteCardWithScores {...props.quotes[0]} skewAngle={-2}>
          {props.quotes[0].content}
        </QuoteCardWithScores>
      </div>}

      <div className={marketingStyles.fullContainerWidth} style={{ background: '#FAFAFA', marginTop: 10 }}>
        <div
          className={cx(
            marketingStyles.dashedBorderHorizontal,
            'align-items-center d-flex gap-s justify-content-center u-padding-A-s'
          )}
        >
          <div className="small">
            <strong>4.8</strong> out of 5
          </div>

          <div style={{ color: '#E1E1E1' }}>・</div>

          <div>
            <a href="https://www.trustpilot.com/review/magoosh.com" target="_blank">
              <img alt="Trustpilot logo" src={TrustpilotLogo} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
